module.exports = __webpack_public_path__ + "static/media/ucon1.738c92ea.JPG";